module.exports = __webpack_public_path__ + "img/iso.645ed3ad.png";